import omit from 'lodash/omit';
import { Observable, Observer } from 'rxjs';

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Params, Router, RouterStateSnapshot } from '@angular/router';

import { LogDetails } from '@app/dashboard/logs/details/log-details.service';

import { getUrlWithoutParams } from '@app/admin/fleet-card/shared/utils';
@Injectable()
export class LogEditItemGuard implements CanActivate {
  constructor(
    private router: Router,
    private service: LogDetails,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    const params = { ...route.params };
    const isRemark: boolean = params.itemType === 'remark';

    const urlWithoutParams: string = getUrlWithoutParams(state.url.replace(isRemark ? '/remark' : '/event', ''), this.router);
    if (!params.offlineId) return true;

    return new Observable<boolean>((observer: Observer<boolean>) => {
      const parentParams: Params = { ...route.parent.params };
      const logId: string = parentParams.id;
      const findItemByOfflineId = (elements: any) => elements.some(element => element.offlineId === params.offlineId);

      this.service.getOnce(logId, params).subscribe(data => {
        const log = data.stagedLog.viewModel;

        if (findItemByOfflineId(isRemark ? log.remarks : log.events)) {
          observer.next(true);
          observer.complete();
        }
        else {
          observer.next(false);
          observer.complete();
          this.router.navigate([urlWithoutParams, omit(params, ['offlineId', 'itemType'])]);
        }
      });
    });
  }
}
